import { AnswerPathTreeNode } from '@zinnia/form-engine-sdk';

import { NodeIds } from '../../nodeIds';

export const insuredWorkCondition: AnswerPathTreeNode = {
  path: 'insuredWorkCondition',
  nodeId: NodeIds.insuredWorkCondition,
};
